import script from "./QModalPolygonTKO.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalPolygonTKO.vue?vue&type=script&setup=true&lang=js"

import "./QModalPolygonTKO.vue?vue&type=style&index=0&id=397767b0&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397767b0"]])

export default __exports__